import { render, staticRenderFns } from "./AnagraficaCompanyDF.vue?vue&type=template&id=459494d2&"
import script from "./AnagraficaCompanyDF.vue?vue&type=script&lang=js&"
export * from "./AnagraficaCompanyDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports